import { Link } from 'react-router-dom';
import { ArrowLeft, Phone } from 'lucide-react';

export default function SupportCrisis() {
  return (
    <div className="p-6 lg:px-10 lg:pt-10 space-y-6 lg:space-y-8 lg:max-w-3xl lg:mx-auto pb-24" data-testid="support-crisis">
      <Link to="/app/support-home" data-testid="support-crisis-back" className="inline-flex items-center gap-2 text-sm text-navy/60 hover:text-navy">
        <ArrowLeft size={14}/> Back to Support Home
      </Link>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-red-600 font-semibold">Crisis Resources</p>
        <h1 className="font-heading text-2xl lg:text-4xl mt-1 lg:mt-2 flex items-center gap-2">
          <Phone size={26} className="text-red-600" strokeWidth={1.75}/>
          If you&apos;re worried right now
        </h1>
        <p className="text-navy/70 mt-3">These lines are free, confidential, and staffed 24/7. Call or text.</p>
      </div>
      <div className="space-y-3">
        {[
          { label: 'Immediate danger', num: '911', href: 'tel:911' },
          { label: 'Suicide & Crisis Lifeline', num: '988', href: 'tel:988' },
          { label: 'Crisis Text Line', num: 'Text HOME to 741741', href: 'sms:741741&body=HOME' },
          { label: 'Veterans Crisis Line', num: 'Dial 988, press 1', href: 'tel:988' },
          { label: 'SAMHSA Helpline', num: '1-800-662-4357', href: 'tel:1-800-662-4357' },
        ].map(l => (
          <a key={l.label} href={l.href} className="block bg-white rounded-2xl p-5 card-soft hover:bg-beige/50 transition-smooth"
            data-testid={`support-crisis-${l.num.slice(0,3)}`}>
            <p className="text-xs uppercase tracking-widest text-navy/50 font-semibold">{l.label}</p>
            <p className="font-heading text-xl mt-1">{l.num}</p>
          </a>
        ))}
      </div>
    </div>
  );
}
